import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Nav from "./sections/Nav";
import Hero from "./sections/Hero";
import TrustRibbon from "./sections/TrustRibbon";
import ProductTour from "./sections/ProductTour";
import ProblemFix from "./sections/ProblemFix";
import FeatureGrid from "./sections/FeatureGrid";
import CopilotSpotlight from "./sections/CopilotSpotlight";
import DepthOfEngine from "./sections/DepthOfEngine";
import Migration from "./sections/Migration";
import Pricing from "./sections/Pricing";
import FinalCTA from "./sections/FinalCTA";
import Footer from "./sections/Footer";
import BookDemoModal from "./sections/BookDemoModal";
import { DemoModalProvider } from "./hooks/useDemoModal";
import { useScrollReveal } from "./hooks/useScrollReveal";

import "./landing.css";

export default function Landing() {
    const rootRef = useRef(null);
    useScrollReveal(rootRef);
    const location = useLocation();

    // When the user lands with /#section (typically via nav from a legal/about page),
    // scroll to that section once the DOM is mounted.
    useEffect(() => {
        const hash = location.hash?.replace(/^#/, "");
        if (!hash) return;
        // Wait for the next paint so section refs / lazy elements exist.
        const id = window.requestAnimationFrame(() => {
            const el = document.getElementById(hash);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        });
        return () => window.cancelAnimationFrame(id);
    }, [location.hash]);

    return (
        <DemoModalProvider>
            <div ref={rootRef} className="vy-landing" data-testid="landing-page">
                <Nav />
                <main>
                    <Hero />
                    <TrustRibbon />
                    <ProductTour />
                    <ProblemFix />
                    <FeatureGrid />
                    <CopilotSpotlight />
                    <DepthOfEngine />
                    <Migration />
                    <Pricing />
                    <FinalCTA />
                </main>
                <Footer />
                <BookDemoModal />
            </div>
        </DemoModalProvider>
    );
}
